import { TRACKERS } from "./Trackers";

export const OBSERVATION_TRACKERS = {
  "363903009": {
    // Sexual behavior -> Sexually active
    EDIT: TRACKERS.EDIT_SEXUALLY_ACTIVE,
    CANCEL: TRACKERS.CANCEL_SEXUALLY_ACTIVE,
    SAVE: TRACKERS.SAVE_SEXUALLY_ACTIVE,
    QUICK_CHART: TRACKERS.QUICK_CHART_SEXUALLY_ACTIVE,
  },
  "423925001": {
    // Family planning -> Contraceptive method
    EDIT: TRACKERS.EDIT_CONTRACEPTIVE_METHOD,
    CANCEL: TRACKERS.CANCEL_CONTRACEPTIVE_METHOD,
    SAVE: TRACKERS.SAVE_CONTRACEPTIVE_METHOD,
    QUICK_CHART: TRACKERS.QUICK_CHART_CONTRACEPTIVE_METHOD,
  },
  "230125005": {
    // Diet followed
    EDIT: TRACKERS.EDIT_DIET_FOLLOWED,
    CANCEL: TRACKERS.CANCEL_DIET_FOLLOWED,
    SAVE: TRACKERS.SAVE_DIET_FOLLOWED,
    QUICK_CHART: TRACKERS.QUICK_CHART_DIET_FOLLOWED,
  },
  "61686008": {
    // Physical exercise
    EDIT: TRACKERS.EDIT_PHYSICAL_EXERCISE,
    CANCEL: TRACKERS.CANCEL_PHYSICAL_EXERCISE,
    SAVE: TRACKERS.SAVE_PHYSICAL_EXERCISE,
    QUICK_CHART: TRACKERS.QUICK_CHART_PHYSICAL_EXERCISE,
  },
  "229819007": {
    // Tobacco use and exposure -> Tobacco use
    EDIT: TRACKERS.EDIT_TOBACCO_USE,
    CANCEL: TRACKERS.CANCEL_TOBACCO_USE,
    SAVE: TRACKERS.SAVE_TOBACCO_USE,
    QUICK_CHART: TRACKERS.QUICK_CHART_TOBACCO_USE,
  },
  "230056004": {
    // Packs per day
    EDIT: TRACKERS.EDIT_PACKS_PER_DAY,
    CANCEL: TRACKERS.CANCEL_PACKS_PER_DAY,
    SAVE: TRACKERS.SAVE_PACKS_PER_DAY,
  },
  "897148007": {
    // Alcoholic beverage intake -> Alcohol use
    EDIT: TRACKERS.EDIT_ALCOHOL_USE,
    CANCEL: TRACKERS.CANCEL_ALCOHOL_USE,
    SAVE: TRACKERS.SAVE_ALCOHOL_USE,
    QUICK_CHART: TRACKERS.QUICK_CHART_ALCOHOL_USE,
  },
  "289152009": {
    // Number of alcoholic drinks per week -> Drinks per week
    EDIT: TRACKERS.EDIT_DRINKS_PER_WEEK,
    CANCEL: TRACKERS.CANCEL_DRINKS_PER_WEEK,
    SAVE: TRACKERS.SAVE_DRINKS_PER_WEEK,
  },
  "1187057000": {
    // Drug use
    EDIT: TRACKERS.EDIT_DRUG_USE,
    CANCEL: TRACKERS.CANCEL_DRUG_USE,
    SAVE: TRACKERS.SAVE_DRUG_USE,
    QUICK_CHART: TRACKERS.QUICK_CHART_DRUG_USE,
  },
  "363908000": {
    // Substance use behavior
    EDIT: TRACKERS.EDIT_SUBSTANCE_USE_BEHAVIOR,
    CANCEL: TRACKERS.CANCEL_SUBSTANCE_USE_BEHAVIOR,
    SAVE: TRACKERS.SAVE_SUBSTANCE_USE_BEHAVIOR,
  },
  "96844-6": {
    // Non-medical use of prescription drugs
    EDIT: TRACKERS.EDIT_NON_MEDICAL_DRUG_USE,
    CANCEL: TRACKERS.CANCEL_NON_MEDICAL_DRUG_USE,
    SAVE: TRACKERS.SAVE_NON_MEDICAL_DRUG_USE,
    QUICK_CHART: TRACKERS.QUICK_CHART_NON_MEDICAL_DRUG_USE,
  },
  "96843-8": {
    // Use of illegal drugs
    EDIT: TRACKERS.EDIT_ILLEGAL_DRUG_USE,
    CANCEL: TRACKERS.CANCEL_ILLEGAL_DRUG_USE,
    SAVE: TRACKERS.SAVE_ILLEGAL_DRUG_USE,
    QUICK_CHART: TRACKERS.QUICK_CHART_ILLEGAL_DRUG_USE,
  },
  "224362002": {
    // Employment Status
    EDIT: TRACKERS.EDIT_EMPLOYMENT_STATUS,
    CANCEL: TRACKERS.CANCEL_EMPLOYMENT_STATUS,
    SAVE: TRACKERS.SAVE_EMPLOYMENT_STATUS,
    QUICK_CHART: TRACKERS.QUICK_CHART_EMPLOYMENT_STATUS,
  },
  "184104002": {
    // Patient occupation -> Occupation
    EDIT: TRACKERS.EDIT_OCCUPATION,
    CANCEL: TRACKERS.CANCEL_OCCUPATION,
    SAVE: TRACKERS.SAVE_OCCUPATION,
    QUICK_CHART: TRACKERS.QUICK_CHART_OCCUPATION,
  },
  "71802-3": {
    // Current housing status
    EDIT: TRACKERS.EDIT_CURRENT_HOUSING_STATUS,
    CANCEL: TRACKERS.CANCEL_CURRENT_HOUSING_STATUS,
    SAVE: TRACKERS.SAVE_CURRENT_HOUSING_STATUS,
    QUICK_CHART: TRACKERS.QUICK_CHART_CURRENT_HOUSING_STATUS,
  },
  "405076007": {
    // Friends & Family Support
    EDIT: TRACKERS.EDIT_FRIENDS_AND_FAMILY_SUPPORT,
    CANCEL: TRACKERS.CANCEL_FRIENDS_AND_FAMILY_SUPPORT,
    SAVE: TRACKERS.SAVE_FRIENDS_AND_FAMILY_SUPPORT,
    QUICK_CHART: TRACKERS.QUICK_CHART_FRIENDS_AND_FAMILY_SUPPORT,
  },
  "364699009": {
    // Ethnicity
    EDIT: TRACKERS.EDIT_ETHNICITY,
    CANCEL: TRACKERS.CANCEL_ETHNICITY,
    SAVE: TRACKERS.SAVE_ETHNICITY,
    QUICK_CHART: TRACKERS.QUICK_CHART_ETHNICITY,
  },
  "103579009": {
    // Race
    EDIT: TRACKERS.EDIT_RACE,
    CANCEL: TRACKERS.CANCEL_RACE,
    SAVE: TRACKERS.SAVE_RACE,
  },
  "21840007": {
    // Date of Last Menstrual Period -> Last menstrual period
    EDIT: TRACKERS.EDIT_LAST_MENSTRUAL_PERIOD,
    CANCEL: TRACKERS.CANCEL_LAST_MENSTRUAL_PERIOD,
    SAVE: TRACKERS.SAVE_LAST_MENSTRUAL_PERIOD,
  },
  "364320009": {
    // Pregnancy observable -> Currently pregnant
    EDIT: TRACKERS.EDIT_CURRENTLY_PREGNANT,
    CANCEL: TRACKERS.CANCEL_CURRENTLY_PREGNANT,
    SAVE: TRACKERS.SAVE_CURRENTLY_PREGNANT,
    QUICK_CHART: TRACKERS.QUICK_CHART_CURRENTLY_PREGNANT,
  },
  "169449001": {
    // Trying to conceive
    EDIT: TRACKERS.EDIT_TRYING_TO_CONCEIVE,
    CANCEL: TRACKERS.CANCEL_TRYING_TO_CONCEIVE,
    SAVE: TRACKERS.SAVE_TRYING_TO_CONCEIVE,
    QUICK_CHART: TRACKERS.QUICK_CHART_TRYING_TO_CONCEIVE,
  },
  "1269101009": {
    // Pregnancy complications
    EDIT: TRACKERS.EDIT_PREGNANCY_COMPLICATIONS,
    CANCEL: TRACKERS.CANCEL_PREGNANCY_COMPLICATIONS,
    SAVE: TRACKERS.SAVE_PREGNANCY_COMPLICATIONS,
    QUICK_CHART: TRACKERS.QUICK_CHART_PREGNANCY_COMPLICATIONS,
  },
  "161732006": {
    // Gravida -> Pregnancies
    EDIT: TRACKERS.EDIT_PREGNANCIES,
    CANCEL: TRACKERS.CANCEL_PREGNANCIES,
    SAVE: TRACKERS.SAVE_PREGNANCIES,
  },
  "440425000": {
    // Number of births at term -> Term births
    EDIT: TRACKERS.EDIT_TERM_BIRTHS,
    CANCEL: TRACKERS.CANCEL_TERM_BIRTHS,
    SAVE: TRACKERS.SAVE_TERM_BIRTHS,
  },
  "252113007": {
    // Number of abortions -> Abortions
    EDIT: TRACKERS.EDIT_ABORTIONS,
    CANCEL: TRACKERS.CANCEL_ABORTIONS,
    SAVE: TRACKERS.SAVE_ABORTIONS,
  },
  "252115000": {
    // Number of cesarean sections -> Cesarean sections
    EDIT: TRACKERS.EDIT_CESAREAN_SECTIONS,
    CANCEL: TRACKERS.CANCEL_CESAREAN_SECTIONS,
    SAVE: TRACKERS.SAVE_CESAREAN_SECTIONS,
  },
  "440537001": {
    // Number of ectopic pregnancies -> Ectopic pregnancies
    EDIT: TRACKERS.EDIT_ECTOPIC_PREGNANCIES,
    CANCEL: TRACKERS.CANCEL_ECTOPIC_PREGNANCIES,
    SAVE: TRACKERS.SAVE_ECTOPIC_PREGNANCIES,
  },
  "248983002": {
    // Obstetric history -> Obstetric history notes
    EDIT: TRACKERS.EDIT_OBSTETRIC_HISTORY_NOTES,
    CANCEL: TRACKERS.CANCEL_OBSTETRIC_HISTORY_NOTES,
    SAVE: TRACKERS.SAVE_OBSTETRIC_HISTORY_NOTES,
  },
  "707087005": {
    // At risk of domestic violence
    EDIT: TRACKERS.EDIT_AT_RISK_OF_DOMESTIC_VIOLENCE,
    CANCEL: TRACKERS.CANCEL_AT_RISK_OF_DOMESTIC_VIOLENCE,
    SAVE: TRACKERS.SAVE_AT_RISK_OF_DOMESTIC_VIOLENCE,
    QUICK_CHART: TRACKERS.QUICK_CHART_AT_RISK_OF_DOMESTIC_VIOLENCE,
  },
  "171222001": {
    // Hypertension screening
    EDIT: TRACKERS.EDIT_HYPERTENSION_SCREENING,
    CANCEL: TRACKERS.CANCEL_HYPERTENSION_SCREENING,
    SAVE: TRACKERS.SAVE_HYPERTENSION_SCREENING,
  },
  "225323000": {
    // Tobacco smoking cessation
    EDIT: TRACKERS.EDIT_TOBACCO_SMOKING_CESSATION,
    CANCEL: TRACKERS.CANCEL_TOBACCO_SMOKING_CESSATION,
    SAVE: TRACKERS.SAVE_TOBACCO_SMOKING_CESSATION,
  },
} as const;

export type ObservationCode = keyof typeof OBSERVATION_TRACKERS;
export type TrackerAction = "EDIT" | "CANCEL" | "SAVE" | "QUICK_CHART";
